export const calculationInputQuery = `
  query CalculationData($comparisonId: UUID!) {
    calculationData(comparisonId: $comparisonId)
  }
`;
